import { render, staticRenderFns } from "./LargeBtn.vue?vue&type=template&id=63a4c6c8&scoped=true&"
import script from "./LargeBtn.vue?vue&type=script&lang=js&"
export * from "./LargeBtn.vue?vue&type=script&lang=js&"
import style0 from "./LargeBtn.vue?vue&type=style&index=0&id=63a4c6c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a4c6c8",
  null
  
)

export default component.exports